"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Provider = void 0;
var react_1 = __importDefault(require("react"));
var ToastProvider_1 = require("./ToastProvider");
/**
 * Provider for all Hegel providers. Should be used near the root of the application.
 */
var Provider = function (_a) {
    var children = _a.children;
    return react_1.default.createElement(ToastProvider_1.ToastProvider, null, children);
};
exports.Provider = Provider;
